import { useLanguage } from '../contexts/LanguageContext'

/** Compact trust hints for the recipient signing screen (not the full TrustBadges list). */
export function SigningTrustMicroRow({ className = '' }) {
  const { t } = useLanguage()
  return (
    <div className={`signing-trust-micro ${className}`.trim()} role="group" aria-label={t('signingTrustMicro.aria')}>
      <span className="signing-trust-micro__item">
        <svg className="signing-trust-micro__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <polyline points="20 6 9 17 4 12" />
        </svg>
        {t('signingTrustMicro.legallyBinding')}
      </span>
      <span className="signing-trust-micro__sep" aria-hidden>
        ·
      </span>
      <span className="signing-trust-micro__item">
        <svg className="signing-trust-micro__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <polyline points="20 6 9 17 4 12" />
        </svg>
        {t('signingTrustMicro.secureEncrypted')}
      </span>
    </div>
  )
}
